import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import VideoUploader from "../../component/VideoUploader/VideoUploader";

const VideoUploadForm = () => {
  return (
    <div className="flex items-center justify-center p-6">
      <VideoUploader />
      <ToastContainer position="top-right" autoClose={2500} hideProgressBar />
    </div>
  );
};

export default VideoUploadForm;
